export const CUSTOMER_TYPE = {
  name: 'Customer',
  value: 'customer',
  localizationSlug: 'CUSTOMER',
  titleize: true,
};

export const INTERNAL_TYPE = {
  name: 'Internal',
  value: 'internal',
  localizationSlug: 'INTERNAL',
};

export const webhookTypes = [CUSTOMER_TYPE, INTERNAL_TYPE];
